import { FieldMappingEditorValue } from '@components/text-editors/addons/field-mapping';
import { useScopedTranslate } from '@locale/translate';

import { buildBaseFieldDefault } from './serialize';

export type BaseFieldDefaults = {
  name: FieldMappingEditorValue;
  email: FieldMappingEditorValue;
  phone: FieldMappingEditorValue;
};

/**
 * Returns the three canonical base-field FieldMappingEditorValue defaults
 * (name, email, phone) with translated variable pill labels.
 *
 * Used both by the add-to-journey sidebar and the global journey config sidebar
 * to seed base field mappings. The variable tokens, source, field, and type
 * come from the single BASE_FIELD_TOKENS source (via buildBaseFieldDefault) —
 * only the pill labels are translated here.
 */
export const useBaseFieldDefaults = (): BaseFieldDefaults => {
  const { t } = useScopedTranslate(locale);

  return {
    name: buildBaseFieldDefault('name', t('applicantFullName')),
    email: buildBaseFieldDefault('email', t('applicationEmail')),
    phone: buildBaseFieldDefault('phone', t('applicationPhone')),
  };
};

const locale = {
  en: {
    applicantFullName: 'Applicant full name',
    applicationEmail: 'Applicant email',
    applicationPhone: 'Applicant phone',
  },
  is: {
    applicantFullName: 'Fullt nafn umsækjanda',
    applicationEmail: 'Netfang umsækjanda',
    applicationPhone: 'Símanúmer umsækjanda',
  },
};
